import type { FunctionComponent, ReactNode } from 'react';

import styles from './DescriptionList.module.css';

export interface DescriptionListProps {
  /** a list of items to display, consisting of `title` and `description` */
  items: Array<{ title: ReactNode; description: ReactNode }>;
}

/**
 * # DescriptionList
 *
 * A list of items with a title and description.
 * */
export const DescriptionList: FunctionComponent<DescriptionListProps> = ({ items }) => {
  return (
    <dl className={styles.descriptionList}>
      {items.map((item, index) => (
        <div className={styles.descriptionList__item} key={index}>
          <dt>{item.title}</dt>
          <dd>{item.description}</dd>
        </div>
      ))}
    </dl>
  );
};
